/*-*-*-*- Navigation Scripts -*-*-*-*/

// Onepage scroll
$(document).ready(function() {
	function scrollToSection(event) {
		event.preventDefault();
		var $section = $($(this).attr('href'));
		$('html, body').animate({
			scrollTop: $section.offset().top -140
		}, 800);
	}
	$('[section-scroll]').on('click', scrollToSection);
});


// Menuhide script + add background in desktopmode by scrolldown
var prevScrollpos = window.pageYOffset;
window.onscroll = function() {
	var currentScrollPos = window.pageYOffset;
	var menuHide = document.getElementById('header');
	
	if (!menuHide) return;
	
	if (window.matchMedia('(max-width: 970px)').matches) {
		if (currentScrollPos > menuHide.offsetHeight) {
			if (prevScrollpos > currentScrollPos) {
				menuHide.style.top = '0';
			} else {
				menuHide.style.top = '-100%';
				document.getElementById('navigation-btn').checked = false;
			}
			prevScrollpos = currentScrollPos;
		}
	} else {
		if($(window).scrollTop() < 50){
			$('#header').css('background','transparent');
		} else if($(window).scrollTop() > 50) {
			$('#header').css('background','hsla(0, 0%, 0%, .6)');
		}
	}
};


/*-*-*-*- Hide/show Script -*-*-*-*/
$('.show-hide').click(function() {
	$('#'+$(this).attr('target')).slideToggle();
});


/*-*-*-*- Login Hide/show Script -*-*-*-*/
$('.show-login').click(function() {
	if ($('#login').css('display') == 'none') {
		$('#'+$(this).attr('target')).slideToggle();
		document.body.style.position = 'fixed';
		document.body.style.overflow = 'hidden';
		document.getElementById('navigation-btn').checked = false;
		$("#main-intro-message").css({"display":"none"});

		} else if ($('#login').css('display') == 'block') {
		$('#'+$(this).attr('target')).slideToggle();
		document.body.style.position = 'relative';
		document.body.style.overflow = 'scroll';
		$("#main-intro-message").css({"display":"block"});
	}
});


/*-*-*-*- with of without BTW Script -*-*-*-*/
$('.abonnementen-btw').click(function () {
	/*-*-*-*- Small -*-*-*-*/
	$('#btw-small-pm').fadeOut(function () {
		$('#btw-small-pm').text(($('#btw-small-pm').text() == '\u20AC 36,30,- ') ? '\u20AC 30,- ' : '\u20AC 36,30,- ').fadeIn();
	})
	$('#btw-small-pj').fadeOut(function () {
		$('#btw-small-pj').text(($('#btw-small-pj').text() == '\u20AC 363,- ') ? '\u20AC 300,- ' : '\u20AC 363,- ').fadeIn();
	})

	/*-*-*-*- Medium -*-*-*-*/
	$('#btw-medium-pm').fadeOut(function () {
		$('#btw-medium-pm').text(($('#btw-medium-pm').text() == '\u20AC 90,75,- ') ? '\u20AC 75,- ' : '\u20AC 90,75,- ').fadeIn();
	})
	$('#btw-medium-pj').fadeOut(function () {
		$('#btw-medium-pj').text(($('#btw-medium-pj').text() == '\u20AC 907,50,- ') ? '\u20AC 750,- ' : '\u20AC 907,50,- ').fadeIn();
	})

	/*-*-*-*- Large -*-*-*-*/
	$('#btw-large-pm').fadeOut(function () {
		$('#btw-large-pm').text(($('#btw-large-pm').text() == '\u20AC 181,50,- ') ? '\u20AC 150,- ' : '\u20AC 181,50,- ').fadeIn();
	})
	$('#btw-large-pj').fadeOut(function () {
	$('#btw-large-pj').text(($('#btw-large-pj').text() == '\u20AC 1815,- ') ? '\u20AC 1500,- ' : '\u20AC 1815,- ').fadeIn();
	})

	/*-*-*-*- Button -*-*-*-*/
	$('.abonnementen-btw').fadeOut(function () {
		$('.abonnementen-btw').text(($('.abonnementen-btw').text() == '*Alle genoemde bedragen zijn inclusies BTW. Klik hier voor bedragen exclusief BTW.') ? '*Alle genoemde bedragen zijn exclusies BTW. Klik hier voor bedragen inclusief BTW.' : '*Alle genoemde bedragen zijn inclusies BTW. Klik hier voor bedragen exclusief BTW.').fadeIn();
	})
})
// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
